import { createSlice } from "@reduxjs/toolkit";

// The initial state of the auth slice is an object with authToken, userAccount, and permissions properties.
const initialState = {
  sessionExpired: false,
  // Why sessionExpired became true — drives which message InactiveLogout's
  // "Session Expired" modal shows. null/"token" covers every existing
  // token-lifecycle path (hard ceiling, MSAL silent-renewal failure); this
  // stays optional so every existing setSessionExpired(true) call site
  // (already several, across getActiveDirectoryAuthToken.js,
  // ErrorHandlingMiddleware.js, InactiveLogout.js itself) keeps working
  // unchanged and reads as the token case.
  sessionExpiredReason: null,
  // Epoch ms when the current session began (set on login, cleared on
  // logout). This is the single clock the whole session-lifecycle policy is
  // built on — see getActiveDirectoryAuthToken.js (hard 1-hour ceiling) and
  // InactiveLogout.js (the "expiring soon" warning) — replacing the old,
  // disconnected 30-minute mouse/keyboard idle timer, which had no relation
  // to how long the user had actually been signed in or to token validity.
  sessionStartedAt: null,
};

// The auth slice is used to maintain the authentication state of the user throughout the application.
export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionExpired: (state, action) => {
      state.sessionExpired = action.payload;
      if (!action.payload) state.sessionExpiredReason = null;
    },
    setSessionExpiredReason: (state, action) => {
      state.sessionExpired = true;
      state.sessionExpiredReason = action.payload;
    },
    setSessionStartedAt: (state, action) => {
      state.sessionStartedAt = action.payload;
    },
  },
});

export const { setSessionExpired, setSessionExpiredReason, setSessionStartedAt } = sessionSlice.actions;
